// extracted by mini-css-extract-plugin
export default {"hover":"TableCellLink_hover__ZtvoC"};